import React from 'react';
import { formatDate } from '@this/src/util';
import { Button } from '@this/shared/ui/inputs/button';
import type { DowngradeSchedule } from './plan_types';

interface Props {
  downgradeSchedule: DowngradeSchedule | null;
  standardPricePerUser: number;
  onOpenDowngradeModal: () => void;
  onOpenCancelDowngradeModal: () => void;
}

export const ProPlanSection = ({
  downgradeSchedule,
  standardPricePerUser,
  onOpenDowngradeModal,
  onOpenCancelDowngradeModal
}: Props) => {
  const styles = getStyles();
  return (
    <>
      {downgradeSchedule ? (
        <div style={styles.downgradeScheduleBox}>
          <div style={styles.downgradeScheduleDetail}>
            {formatDate(downgradeSchedule.effective_at, 'YYYY年M月D日')}に {downgradeSchedule.to_plan_name}
            プランへ変更予定
          </div>
          <div style={styles.downgradeScheduleMeta}>
            <span>登録日時：{formatDate(downgradeSchedule.scheduled_at, 'YYYY年M月D日 HH:mm')}</span>
            {downgradeSchedule.scheduled_by_name && <span>登録者：{downgradeSchedule.scheduled_by_name}</span>}
          </div>
          <Button style={styles.button} onClick={onOpenCancelDowngradeModal}>
            ダウングレードを取り消す
          </Button>
        </div>
      ) : (
        <>
          <Button style={styles.button} color="sub" onClick={onOpenDowngradeModal}>
            AI Expense Standard にダウングレード
          </Button>
          <ul style={styles.ul}>
            <li style={styles.li}>月額{standardPricePerUser}円（税込、1ユーザあたり）</li>
            <li style={styles.li}>OCR機能は利用できなくなります</li>
          </ul>
        </>
      )}
    </>
  );
};

function getStyles() {
  const buttonBase: React.CSSProperties = { width: 'fit-content', borderRadius: '4px', marginBottom: '12px' };
  return {
    button: buttonBase,
    ul: { listStyleType: 'disc', paddingLeft: '25px', marginTop: '10px' } as React.CSSProperties,
    li: { marginBottom: '5px', fontWeight: 300, fontSize: '1.125em' } as React.CSSProperties,
    downgradeScheduleBox: {
      padding: '16px',
      borderRadius: '6px',
      border: '1px solid #e0e0e0',
      backgroundColor: '#fafafa',
      marginBottom: '16px'
    } as React.CSSProperties,
    downgradeScheduleBoxHeader: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#7d7d7d',
      textTransform: 'uppercase' as const,
      letterSpacing: '0.05em',
      marginBottom: '8px'
    } as React.CSSProperties,
    downgradeScheduleDetail: { marginBottom: '8px', fontSize: '14px' } as React.CSSProperties,
    downgradeScheduleMeta: {
      display: 'flex',
      gap: '24px',
      marginBottom: '16px',
      color: '#7d7d7d',
      fontSize: '12px'
    } as React.CSSProperties
  } as const;
}
